/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Home_Stat_Pga_TeacherInputs */

const en_home_stat_pga_teacher = /** @type {(inputs: Home_Stat_Pga_TeacherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa PGA Teacher of the Year`)
};

const es_home_stat_pga_teacher = /** @type {(inputs: Home_Stat_Pga_TeacherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Profesor del Año de la Iowa PGA`)
};

const de_home_stat_pga_teacher = /** @type {(inputs: Home_Stat_Pga_TeacherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lehrer des Jahres der Iowa PGA`)
};

const zh_home_stat_pga_teacher = /** @type {(inputs: Home_Stat_Pga_TeacherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa PGA 年度最佳教师`)
};

const ar_home_stat_pga_teacher = /** @type {(inputs: Home_Stat_Pga_TeacherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`معلم العام في Iowa PGA`)
};

const fr_home_stat_pga_teacher = /** @type {(inputs: Home_Stat_Pga_TeacherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enseignant de l’année de la Iowa PGA`)
};

const vi_home_stat_pga_teacher = /** @type {(inputs: Home_Stat_Pga_TeacherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Giáo viên của năm của Iowa PGA`)
};

const sw_home_stat_pga_teacher = /** @type {(inputs: Home_Stat_Pga_TeacherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mwalimu Bora wa Mwaka wa Iowa PGA`)
};

const th_home_stat_pga_teacher = /** @type {(inputs: Home_Stat_Pga_TeacherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ครูแห่งปีของ Iowa PGA`)
};

const bs_home_stat_pga_teacher = /** @type {(inputs: Home_Stat_Pga_TeacherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Učitelj godine Iowa PGA`)
};

const ja_home_stat_pga_teacher = /** @type {(inputs: Home_Stat_Pga_TeacherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa PGA 年間最優秀教師`)
};

const ko_home_stat_pga_teacher = /** @type {(inputs: Home_Stat_Pga_TeacherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa PGA 올해의 교사`)
};

const pt_home_stat_pga_teacher = /** @type {(inputs: Home_Stat_Pga_TeacherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Professor do Ano da Iowa PGA`)
};

const it_home_stat_pga_teacher = /** @type {(inputs: Home_Stat_Pga_TeacherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Insegnante dell’anno della Iowa PGA`)
};

const sv_home_stat_pga_teacher = /** @type {(inputs: Home_Stat_Pga_TeacherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Årets lärare i Iowa PGA`)
};

const nl_home_stat_pga_teacher = /** @type {(inputs: Home_Stat_Pga_TeacherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leraar van het Jaar van de Iowa PGA`)
};

const da_home_stat_pga_teacher = /** @type {(inputs: Home_Stat_Pga_TeacherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Årets træner i Iowa PGA`)
};

const nb_home_stat_pga_teacher = /** @type {(inputs: Home_Stat_Pga_TeacherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Årets lærer i Iowa PGA`)
};

const fi_home_stat_pga_teacher = /** @type {(inputs: Home_Stat_Pga_TeacherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa PGA:n vuoden opettaja`)
};

const pl_home_stat_pga_teacher = /** @type {(inputs: Home_Stat_Pga_TeacherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nauczyciel Roku Iowa PGA`)
};

const ru_home_stat_pga_teacher = /** @type {(inputs: Home_Stat_Pga_TeacherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Учитель года Iowa PGA`)
};

const tr_home_stat_pga_teacher = /** @type {(inputs: Home_Stat_Pga_TeacherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa PGA Yılın Öğretmeni`)
};

const hi_home_stat_pga_teacher = /** @type {(inputs: Home_Stat_Pga_TeacherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa PGA वर्ष के सर्वश्रेष्ठ शिक्षक`)
};

const id_home_stat_pga_teacher = /** @type {(inputs: Home_Stat_Pga_TeacherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa PGA Teacher of the Year`)
};

const ms_home_stat_pga_teacher = /** @type {(inputs: Home_Stat_Pga_TeacherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa PGA Teacher of the Year`)
};

const cs_home_stat_pga_teacher = /** @type {(inputs: Home_Stat_Pga_TeacherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Učitel roku Iowa PGA`)
};

const el_home_stat_pga_teacher = /** @type {(inputs: Home_Stat_Pga_TeacherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Δάσκαλος της Χρονιάς της Iowa PGA`)
};

const he_home_stat_pga_teacher = /** @type {(inputs: Home_Stat_Pga_TeacherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מורה השנה של Iowa PGA`)
};

const af_home_stat_pga_teacher = /** @type {(inputs: Home_Stat_Pga_TeacherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Iowa PGA Onderwyser van die Jaar`)
};

const hu_home_stat_pga_teacher = /** @type {(inputs: Home_Stat_Pga_TeacherInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Az Iowa PGA év tanára`)
};

/**
* | output |
* | --- |
* | "Iowa PGA Teacher of the Year" |
*
* @param {Home_Stat_Pga_TeacherInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const home_stat_pga_teacher = /** @type {((inputs?: Home_Stat_Pga_TeacherInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Stat_Pga_TeacherInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_home_stat_pga_teacher(inputs)
	if (locale === "de") return de_home_stat_pga_teacher(inputs)
	if (locale === "zh") return zh_home_stat_pga_teacher(inputs)
	if (locale === "ar") return ar_home_stat_pga_teacher(inputs)
	if (locale === "fr") return fr_home_stat_pga_teacher(inputs)
	if (locale === "vi") return vi_home_stat_pga_teacher(inputs)
	if (locale === "sw") return sw_home_stat_pga_teacher(inputs)
	if (locale === "th") return th_home_stat_pga_teacher(inputs)
	if (locale === "bs") return bs_home_stat_pga_teacher(inputs)
	if (locale === "ja") return ja_home_stat_pga_teacher(inputs)
	if (locale === "ko") return ko_home_stat_pga_teacher(inputs)
	if (locale === "pt") return pt_home_stat_pga_teacher(inputs)
	if (locale === "it") return it_home_stat_pga_teacher(inputs)
	if (locale === "sv") return sv_home_stat_pga_teacher(inputs)
	if (locale === "nl") return nl_home_stat_pga_teacher(inputs)
	if (locale === "da") return da_home_stat_pga_teacher(inputs)
	if (locale === "nb") return nb_home_stat_pga_teacher(inputs)
	if (locale === "fi") return fi_home_stat_pga_teacher(inputs)
	if (locale === "pl") return pl_home_stat_pga_teacher(inputs)
	if (locale === "ru") return ru_home_stat_pga_teacher(inputs)
	if (locale === "tr") return tr_home_stat_pga_teacher(inputs)
	if (locale === "hi") return hi_home_stat_pga_teacher(inputs)
	if (locale === "id") return id_home_stat_pga_teacher(inputs)
	if (locale === "ms") return ms_home_stat_pga_teacher(inputs)
	if (locale === "cs") return cs_home_stat_pga_teacher(inputs)
	if (locale === "el") return el_home_stat_pga_teacher(inputs)
	if (locale === "he") return he_home_stat_pga_teacher(inputs)
	if (locale === "af") return af_home_stat_pga_teacher(inputs)
	if (locale === "hu") return hu_home_stat_pga_teacher(inputs)
	return en_home_stat_pga_teacher(inputs)
});